<template>
    <div class="lds-ring" ref="ring" :style="`height: ${sizing};width: ${sizing}`"><div></div><div></div><div></div><div></div></div>
</template>

<script>
export default {
    name:'base-spinner',
    props: ["size"],
    mounted() {
        Array.from(this.$refs.ring.children).forEach(item => {
            item .style['height'] = this.sizing;
            item.style['width'] = this.sizing;
        });
    },
    data() {
        //eslint-disable-next-line no-unused-labels
        return {
            own_size: this.size==='small'?21:this.size==='medium'?42:64,
        };
    },
    computed: {
        sizing() {
            return `${this.own_size}px`;
        },
    },
};
</script>

<style scoped lang="scss">
@import './BaseSpinner.scss';
</style>
